// TODO Replace Enum to Object and update valid types for that
export enum ExportCostTypeItem {
    Excel = "excel",
    Salesforce = "salesforce",
    Hubspot = "hubSpot",
    SalesforceLead = "salesforceLead",
    Dynamics = "dynamics",
    DynamicsLead = "dynamicsLead",
    Competitors = "competitors",
}
